(() => {
  const contextNode = document.getElementById("AloeFunnelContext"),
    context = contextNode ? JSON.parse(contextNode.textContent || "{}") : {},
    sent = new Set(),
    clean = (value) => String(value || "").slice(0, 120),
    emit = (name, detail = {}, onceKey = "") => {
      const key = onceKey || "";
      if (key && sent.has(key)) return;
      key && sent.add(key);
      let audience = "business";
      try {
        audience = clean(
          localStorage.getItem("aloe-price-audience") || "business",
        );
      } catch {
        audience = "business";
      }
      const payload = {
        event: name,
        page_type: clean(context.pageType),
        page_path: window.location.pathname,
        product_id: clean(detail.productId || context.productId),
        variant_id: clean(detail.variantId || context.variantId),
        product_title: clean(detail.productTitle || context.productTitle),
        value: Number(detail.value ?? context.value ?? 0) || 0,
        currency: clean(context.currency || "EUR"),
        audience,
        source: clean(detail.source || "storefront"),
      };
      ((window.dataLayer = window.dataLayer || []),
        window.dataLayer.push(payload),
        typeof window.fbq == "function" &&
          window.fbq("trackCustom", name, payload),
        document.dispatchEvent(
          new CustomEvent("aloe:tracked", { detail: payload }),
        ));
    };
  ((window.AloeTracking = { emit }),
    context.pageType === "product" &&
      emit("aloe_product_view", {}, `view:${context.productId}`),
    window.location.pathname === "/pages/aloe15" &&
      emit("aloe15_landing_view", {}, "aloe15-view"),
    document.addEventListener("click", (event) => {
      event.target.closest(
        '#aloe-design-btn, [href="#aloe-designer-overlay"]',
      ) && emit("aloe_designer_open", { source: "product_page" });
      const campaignCta = event.target.closest("[data-aloe15-cta]");
      (campaignCta &&
        emit("aloe15_cta_click", {
          source: clean(campaignCta.dataset.aloe15Cta),
        }),
        event.target.closest(
          '#submit-quote, [data-aq-submit], form[action*="contact"] [type="submit"]',
        ) && emit("aloe_quote_submit", { source: "quote_form" }));
    }),
    document.addEventListener("change", (event) => {
      const input = event.target;
      if (
        !(input instanceof HTMLInputElement) ||
        input.type !== "file" ||
        !input.files?.length
      )
        return;
      const extension =
        input.files[0].name.split(".").pop()?.toLowerCase() || "";
      emit("aloe_logo_upload", { source: `file_${clean(extension)}` });
    }),
    document.addEventListener("aloe:cart-added", (event) => {
      emit("aloe_add_to_cart", event.detail || {});
    }),
    document.addEventListener("aloe:designer-added", (event) => {
      emit("aloe_designer_add_to_cart", {
        ...(event.detail || {}),
        source: "designer",
      });
    }));
})();
